import React from 'react';
import { Helmet } from 'react-helmet-async';
import {PageTile} from "../../../const/const";

const PageMeta = ({ title = PageTile, mangaName = "", mangaDescription = "", url_image = "", url_manga = "" }) => {
    return (
        <Helmet>
            <meta name="title" content={title}/>
            <meta
                name="description"
                content={`Đọc truyện ${mangaName} bản full đầy đủ chap mới nhất với hình ảnh sắc nét, truyện tải nhanh, không quảng cáo tại MangaDaily`}
            />
            <meta property="og:type" content="book"/>
            <meta property="og:title" content={mangaName}/>
            <meta property="og:description"
                  content={`Đọc truyện ${mangaName} bản full đầy đủ chap mới nhất với hình ảnh sắc nét, truyện tải nhanh, không quảng cáo tại MangaDaily`}
            />
            <meta property="og:image" content={url_image}/>
            <meta property="og:url" content={`http://localhost:3000${url_manga}`}/>
            <meta property="og:site_name" content='MangaDaily'/>
        </Helmet>
    );
};

export default PageMeta;